import { render, staticRenderFns } from "./SafetyPreventionRequest.vue?vue&type=template&id=d81e3fd2&scoped=true"
import script from "./SafetyPreventionRequest.vue?vue&type=script&lang=js"
export * from "./SafetyPreventionRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81e3fd2",
  null
  
)

export default component.exports